import React, { useState } from "react";
import { ArrowRight, Check, Phone } from "lucide-react";
import { siteData } from "../mock";

export default function Services() {
  const [i, setI] = useState(0);
  const s = siteData.services[i];
  const { whatsapp, primaryPhoneRaw } = siteData.brand;

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-[11px] tracking-[0.32em] text-[#b88b4a] mb-5">WHAT WE DO</div>
        <h2 className="font-serif text-neutral-900 text-[42px] leading-[1.08] md:text-[68px] md:leading-[1.03] tracking-tight max-w-4xl">
          Three pillars, <span className="italic">one trusted partner.</span>
        </h2>
        <p className="mt-7 md:mt-8 text-neutral-700 text-[15.5px] md:text-[17px] leading-[1.8] max-w-2xl">
          From your family&apos;s forever home to your company&apos;s headquarters and manufacturing unit — JK Estates handles every property category across the Tricity with the same diligence and transparency.
        </p>

        <div className="mt-14 md:mt-16 border border-[#e7e2d7]">
          <div className="grid md:grid-cols-2">
            {/* Image / visual side */}
            <div className="relative aspect-[5/4] md:aspect-auto md:min-h-[560px] overflow-hidden bg-[#0f1a2e]">
              {s.image ? (
                <img src={s.image} alt={s.title} className="absolute inset-0 w-full h-full object-cover transition-opacity duration-500" />
              ) : (
                <div className="absolute inset-0" style={{backgroundImage: "radial-gradient(circle at 20% 20%, rgba(198,160,113,0.18) 1px, transparent 1px), radial-gradient(circle at 80% 80%, rgba(198,160,113,0.12) 1px, transparent 1px)", backgroundSize: "28px 28px, 36px 36px"}} />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent" />
              <div className="absolute top-6 left-6 right-6 flex items-center justify-between text-white">
                <div className="text-[11px] tracking-[0.3em] text-[#c6a071]">{s.num} · {s.kicker}</div>
                <div className="text-[12px] text-white/85 tracking-wide">{String(i+1).padStart(2,"0")} / {String(siteData.services.length).padStart(2,"0")}</div>
              </div>
              <div className="absolute bottom-6 left-6 right-6 text-white font-serif text-[38px] md:text-[48px] leading-[1.05]">{s.title}</div>
            </div>

            {/* Content side */}
            <div className="p-8 md:p-12 bg-white">
              <div className="text-[11px] tracking-[0.3em] text-[#b88b4a] mb-4">{s.kicker}</div>
              <h3 className="font-serif text-neutral-900 text-[32px] md:text-[40px] leading-[1.1]">{s.title}</h3>
              <p className="mt-5 text-neutral-700 text-[15px] md:text-[16px] leading-[1.8]">{s.desc}</p>

              <ul className="mt-8 space-y-4">
                {s.points.map((pt) => (
                  <li key={pt} className="flex items-start gap-3 text-neutral-800 text-[15px]">
                    <Check className="w-4 h-4 mt-1 text-[#b88b4a] shrink-0" strokeWidth={2} />
                    <span>{pt}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-10 flex flex-col sm:flex-row gap-3">
                <a href={`tel:${primaryPhoneRaw}`} className="btn-dark inline-flex items-center justify-center gap-2 px-6 py-3.5 text-[13px] tracking-wide">
                  <Phone className="w-4 h-4" /> Talk to a Consultant
                </a>
                <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer" className="btn-outline-dark inline-flex items-center justify-center gap-2 px-6 py-3.5 text-[13px] tracking-wide">
                  WhatsApp Enquiry <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-[#e7e2d7] flex items-center justify-between px-6 md:px-10 py-4 bg-jk-cream">
            <div className="text-[11px] tracking-[0.25em] text-neutral-600">{s.num} / 03</div>
            <div className="flex items-center gap-2">
              {siteData.services.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setI(idx)}
                  aria-label={`Show service ${idx+1}`}
                  className={`h-[3px] transition-all ${i === idx ? "w-10 bg-[#b88b4a]" : "w-5 bg-neutral-300 hover:bg-neutral-400"}`}
                />
              ))}
            </div>
            <div className="flex items-center gap-1">
              <button onClick={() => setI((i - 1 + siteData.services.length) % siteData.services.length)} className="w-9 h-9 border border-neutral-300 hover:border-neutral-800 flex items-center justify-center transition-colors" aria-label="Previous">
                <ArrowRight className="w-4 h-4 rotate-180" />
              </button>
              <button onClick={() => setI((i + 1) % siteData.services.length)} className="w-9 h-9 border border-neutral-300 hover:border-neutral-800 flex items-center justify-center transition-colors" aria-label="Next">
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
